import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { DateTimeModes } from '../common-components/date-selector/date.selector.util';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TimeProvider {
  private _startDate = new Date();
  private _endDate = new Date();
  currentDate = new Date();
  selectedDate: any;
  t_period: any;

  selectedMonth: any;
  selectedWeek: any;
  customRangeStDate = moment();
  customRangeEndDate = moment();
  timeMode = DateTimeModes.TODAY;
  dateNodeType = 'normal';
  initialSelection = true;
  customRangeInit = true;
  customDateStr = '';
  selectedDateNode: {
    topic: string;
    hoverVal: any;
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  } = {
    topic: '',
    hoverVal: '',
    startDate: null,
    endDate: null,
  };
  selectedMonthWeekNode: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
    selected: boolean;
  } = {
    startDate: null,
    endDate: null,
    selected: false,
  };

  private timeModeChage = new Subject();
  public readonly timeModeChangeChannel = this.timeModeChage.asObservable();
  public onGlobalDateChange = new Subject<string>();

  constructor(private translate: TranslateService) {
    const dataLabel = moment().format('MM/DD/YYYY');
    this.selectedDate = {
      chosenLabel: dataLabel,
      startDate: moment(),
      endDate: moment(),
    };
  }
  get startDate(): Date {
    return this._startDate;
  }

  get endDate(): Date {
    return this._endDate;
  }
  getNDaysTime(num: number) {
    const startDate = new Date(this.currentDate.toDateString());
    const client = Math.abs(startDate.getTimezoneOffset());
    const mins = client % 60;
    const hours = Math.trunc(client / 60);
    const n = startDate.getDate() - num;
    startDate.setHours(hours, mins);

    let time1 = startDate.getTime();
    time1 = time1 + 23 * 60 * 60 * 1000 + 59 * 60000; // end of the day time

    const endDate = new Date(time1);
    startDate.setDate(n);
    return startDate.toISOString() + '/' + endDate.toISOString();
  }

  getCurrentDate() {
    const dateString = new DatePipe('en').transform(this.currentDate, 'yyyy-MM-dd');
    return dateString;
  }

  setCurrentDate(dateString) {
    this.currentDate = new Date(dateString);
  }

  setTimeMode(cat) {
    this.timeMode = cat;
    this.timeModeChage.next(cat);
  }

  // added in Version 2
  getDateTimes(param) {
    if (param === 'Today') {
      return this.getTodayDateStr();
    } else if (param === 'Yesterday') {
      return this.getYesterdayDateStr();
    } else if (param === 'Last 7 days') {
      return this.getlastSevenDaysDateStr();
    } else if (param === 'Last 15 days') {
      return this.getlastFifteenDaysDateStr();
    } else if (param === 'This month') {
      return this.getThisMonthDaysDateStr();
    } else if (param === 'Last month') {
      return this.getLastMonthDaysDateStr();
    } else if (param === 'Last 3 months') {
      return this.getLastThreeMonthsDaysDateStr();
    }
    return null;
  }

  // added in Version 2
  getCustomDatesStr(dates) {
    const date1 = moment(dates.start).utc(true).format('DD');
    const d1Year = moment(dates.start).utc(true).format('YYYY');
    const d1Month = moment(dates.start).utc(true).format('MMM');
    const date2 = moment(dates.end).utc(true).format('DD');
    const d2Year = moment(dates.end).utc(true).format('YYYY');
    const d2Month = moment(dates.end).utc(true).format('MMM');

    let formattedDate;
    if (date1 === date2 && d1Month === d2Month && d1Year === d2Year) {
      formattedDate = date1 + ' ' + d1Month + ' ' + d1Year;
      this.customDateStr = formattedDate;
      return formattedDate;
    }
    if (d1Year === d2Year) {
      formattedDate = date1 + ' ' + d1Month + ' to ' + date2 + ' ' + d2Month + ' ' + d1Year;
      this.customDateStr = formattedDate;
    } else {
      formattedDate = date1 + ' ' + d1Month + ' ' + d1Year + ' to ' + date2 + ' ' + d2Month + ' ' + d2Year;
      this.customDateStr = formattedDate;
    }
    return formattedDate;
  }

  // added in Version 2
  getTodayDateStr() {
    const startDay = moment().utc(true).startOf('day');
    const endDay = moment().utc(true).endOf('day');
    const dayS = moment().utc(true).format('DD');
    const monthS = moment().utc(true).format('MMM');
    const yearS = moment().utc(true).format('YYYY');
    const formattedDate = dayS + ' ' + monthS + ' ' + yearS;
    const returnData = {
      startDate: startDay,
      endDate: endDay,
      hover: formattedDate,
    };
    return returnData;
  }

  // added in Version 2
  getYesterdayDateStr() {
    const startDay = moment().utc(true).subtract(1, 'day').startOf('day');
    const endDay = moment().utc(true).subtract(1, 'day').endOf('day');
    const dayS = moment().utc(true).subtract(1, 'day').format('DD');
    const monthS = moment().utc(true).subtract(1, 'day').format('MMM');
    const yearS = moment().utc(true).subtract(1, 'day').format('YYYY');
    const formattedDate = dayS + ' ' + monthS + ' ' + yearS;
    const returnData = {
      startDate: startDay,
      endDate: endDay,
      hover: formattedDate,
    };
    return returnData;
  }

  // added in Version 2
  getlastSevenDaysDateStr() {
    const startDay = moment().utc(true).subtract(6, 'day').startOf('day');
    const endDay = moment().utc(true).endOf('day');
    const startDayS = moment().utc(true).subtract(6, 'day').startOf('day').format('DD');
    const endDayS = moment().utc(true).endOf('day').format('DD');
    const startMonthS = moment().utc(true).subtract(6, 'day').startOf('day').format('MMM');
    const endMonthS = moment().utc(true).endOf('day').format('MMM');
    const startYearS = moment().utc(true).subtract(6, 'day').startOf('day').format('YYYY');
    const endYearS = moment().utc(true).endOf('day').format('YYYY');
    let formattedDate;
    if (startYearS === endYearS) {
      formattedDate = startDayS + ' ' + startMonthS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    } else {
      formattedDate =
        startDayS + ' ' + startMonthS + ' ' + startYearS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    }
    const returnData = {
      startDate: startDay,
      endDate: endDay,
      hover: formattedDate,
    };
    return returnData;
  }

  // added in Version 2
  getlastFifteenDaysDateStr() {
    const startDay = moment().utc(true).subtract(14, 'day').startOf('day');
    const endDay = moment().utc(true).endOf('day');
    const startDayS = moment().utc(true).subtract(14, 'day').startOf('day').format('DD');
    const endDayS = moment().utc(true).endOf('day').format('DD');
    const startMonthS = moment().utc(true).subtract(14, 'day').startOf('day').format('MMM');
    const endMonthS = moment().utc(true).endOf('day').format('MMM');
    const startYearS = moment().utc(true).subtract(14, 'day').startOf('day').format('YYYY');
    const endYearS = moment().utc(true).endOf('day').format('YYYY');
    let formattedDate;
    if (startYearS === endYearS) {
      formattedDate = startDayS + ' ' + startMonthS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    } else {
      formattedDate =
        startDayS + ' ' + startMonthS + ' ' + startYearS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    }
    const returnData = {
      startDate: startDay,
      endDate: endDay,
      hover: formattedDate,
    };
    return returnData;
  }

  // added in Version 2
  getThisMonthDaysDateStr() {
    const startDay = moment().utc(true).startOf('month');
    const endDay = moment().utc(true).endOf('day');
    const startDayS = moment().utc(true).startOf('month').format('DD');
    const endDayS = moment().utc(true).endOf('day').format('DD');
    const startMonthS = moment().utc(true).startOf('month').format('MMM');
    const endMonthS = moment().utc(true).endOf('day').format('MMM');
    const startYearS = moment().utc(true).startOf('month').format('YYYY');
    const endYearS = moment().utc(true).endOf('day').format('YYYY');
    let formattedDate;
    if (startYearS === endYearS) {
      formattedDate = startDayS + ' ' + startMonthS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    } else {
      formattedDate =
        startDayS + ' ' + startMonthS + ' ' + startYearS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    }
    const returnData = {
      startDate: startDay,
      endDate: endDay,
      hover: formattedDate,
    };
    return returnData;
  }

  // added in Version 2
  getLastMonthDaysDateStr() {
    const startDay = moment().utc(true).subtract(1, 'month').startOf('month');
    const endDay = moment().utc(true).subtract(1, 'month').endOf('month');
    const startDayS = moment().utc(true).subtract(1, 'month').startOf('month').format('DD');
    const endDayS = moment().utc(true).subtract(1, 'month').endOf('month').format('DD');
    const startMonthS = moment().utc(true).subtract(1, 'month').startOf('month').format('MMM');
    const endMonthS = moment().utc(true).subtract(1, 'month').endOf('month').format('MMM');
    const startYearS = moment().utc(true).subtract(1, 'month').startOf('month').format('YYYY');
    const endYearS = moment().utc(true).subtract(1, 'month').endOf('month').format('YYYY');
    let formattedDate;
    if (startYearS === endYearS) {
      formattedDate = startDayS + ' ' + startMonthS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    } else {
      formattedDate =
        startDayS + ' ' + startMonthS + ' ' + startYearS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    }
    const returnData = {
      startDate: startDay,
      endDate: endDay,
      hover: formattedDate,
    };
    return returnData;
  }

  // added in Version 2
  getLastThreeMonthsDaysDateStr() {
    const startDay = moment().utc(true).subtract(3, 'month').startOf('month');
    const endDay = moment().utc(true).subtract(1, 'month').endOf('month');
    const startDayS = moment().utc(true).subtract(3, 'month').startOf('month').format('DD');
    const endDayS = moment().utc(true).subtract(1, 'month').endOf('month').format('DD');
    const startMonthS = moment().utc(true).subtract(3, 'month').startOf('month').format('MMM');
    const endMonthS = moment().utc(true).subtract(1, 'month').endOf('month').format('MMM');
    const startYearS = moment().utc(true).subtract(3, 'month').startOf('month').format('YYYY');
    const endYearS = moment().utc(true).subtract(1, 'month').endOf('month').format('YYYY');
    let formattedDate;
    if (startYearS === endYearS) {
      formattedDate = startDayS + ' ' + startMonthS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    } else {
      formattedDate =
        startDayS + ' ' + startMonthS + ' ' + startYearS + ' to ' + endDayS + ' ' + endMonthS + ' ' + endYearS;
    }
    const returnData = {
      startDate: startDay,
      endDate: endDay,
      hover: formattedDate,
    };
    return returnData;
  }

  setEndDate(num) {
    const endDate = new Date(this.currentDate.toDateString());
    const n = endDate.getDate() + num;
    endDate.setDate(n);

    this._endDate = endDate;
  }

  // TODO : remove timeMode variable
  getStartDateKebab() {
    const stdate = moment(this._startDate.getTime()).format('YYYY-MM-DD');
    return stdate;
  }

  // TODO : remove timeMode variable
  getEndDateKebab(n?: number) {
    let ed;
    const date_arr_daily = this._endDate.toISOString().split('T');
    ed = date_arr_daily[0];
    ed = this.checkCurrentDate(ed);
    return ed;
  }

  checkCurrentDate(date, windowIncrease?: boolean) {
    let checkDate;
    let currentDate;
    if (windowIncrease) {
      checkDate = moment(date).add(1, 'day').format('YYYY-MM-DD');
      currentDate = moment().add(1, 'day').format('YYYY-MM-DD');
    } else {
      checkDate = moment(date).format('YYYY-MM-DD');
      currentDate = moment().format('YYYY-MM-DD');
    }

    return moment(checkDate).valueOf() > moment(currentDate).valueOf() ? currentDate : checkDate;
  }

  // this is for update window time using config
  updateWindowBufferTime(days: number, date) {
    return moment(date).subtract(days, 'day').toISOString();
  }

  getSelectedDate() {
    return this.selectedDate;
  }

  setSelectedDate(range) {
    this.selectedDate = range;
  }

  // get @window for selected time mode
  getWindow(days: number = 0, windowIncrease?: boolean) {
    // console.log("selected time mode", this.timeMode);
    // if component need add buffer time into window user can add number of days
    return (
      this.updateWindowBufferTime(days, this._startDate) +
      '/' +
      this.checkCurrentDate(this._endDate, windowIncrease) +
      'T23:59:59.999Z'
    );
  }

  setCurrentDay(date) {
    this.t_period = date.toISOString();
    return this.t_period;
  }

  getCurrentWeek() {
    const startDate = moment().utc(true).startOf('week');
    const endDate = moment().utc(true).endOf('week');

    this.t_period = startDate.toISOString() + '/' + endDate.toISOString();
    return this.t_period;
  }

  setTwoWeeks(windowIncrease?: boolean) {
    const startDate = moment(this._startDate).utc(true).subtract(1, 'weeks').startOf('week');
    const endDate = this._endDate; // moment().utc(true).endOf('week');

    if (windowIncrease) {
      return startDate.toISOString() + '/' + moment(endDate).utc(true).add(1, 'day').toISOString();
    }
    return startDate.toISOString() + '/' + endDate.toISOString();
  }

  getCurrentMonths() {
    const startDate = moment().utc(true).startOf('month');
    const endDate = moment().utc(true).endOf('month');

    return startDate.toISOString() + '/' + endDate.toISOString();
  }

  updateEndDate(endIsoDateString) {
    const dateStr = moment(endIsoDateString).endOf('day').format('DD-MMM-YYYY HH:mm:ss');
    this._endDate = moment(dateStr).toDate();
  }

  updateStartDate(startIsoDateString) {
    const dateStr = moment(startIsoDateString).startOf('day').format(moment.defaultFormatUtc);
    this._startDate = moment(dateStr).toDate();
  }

  // for the headings
  // TODO : remove type variable
  getSelectedDateRange(type) {
    if (type === 'daily') {
      return (
        new DatePipe('en').transform(this._startDate.toISOString(), 'dd/MM/yyyy') +
        ' -- ' +
        new DatePipe('en').transform(this._endDate.toISOString().split('T')[0], 'dd/MM/yyyy')
      );
    }

    if (type === 'weekly') {
      return (
        new DatePipe('en').transform(this._startDate.toISOString(), 'dd/MM/yyyy') +
        ' -- ' +
        new DatePipe('en').transform(this._endDate.toISOString().split('T')[0], 'dd/MM/yyyy')
      );
    }

    if (type === 'monthly') {
      return new DatePipe('en').transform(this._startDate.toISOString(), 'MMMM');
    }
    return null;
  }

  updateTempMonth(start, end) {
    this.selectedMonth = { start, end };
  }

  getUpdatedMonth() {
    return this.selectedMonth;
  }

  updateTempWeek(start, end) {
    this.selectedWeek = { start, end };
  }

  getUpdatedWeek() {
    return this.selectedWeek;
  }

  selectedDateRange() {
    return this.getDisplayDateRanges(this._startDate, this._endDate);
  }

  getDisplayDateRanges(startDate: Date, endDate: Date): string {
    const [correctedStartDate, correctedEndDate] = this.getCorrectedDateRanges(moment(startDate), moment(endDate));

    if (!correctedEndDate) {
      return this.getSingleDateStr(moment(startDate));
    }

    return this.getDateRangeStr(correctedStartDate, correctedEndDate);
  }

  getCorrectedDateRanges(startDate: moment.Moment, endDate: moment.Moment): moment.Moment[] {
    const currentDate = moment(new Date());

    if (currentDate.isSame(startDate, 'day')) {
      return [startDate, currentDate];
    }

    if (currentDate.isBefore(endDate, 'day')) {
      return [startDate, currentDate];
    }

    return [startDate, endDate];
  }

  private getDateRangeStr(initialDate: moment.Moment, lastDate: moment.Moment): string {
    if (initialDate.isSame(lastDate, 'day')) {
      return this.getSingleDateStr(initialDate);
    } else {
      return this.getMultipleDateStr(initialDate, lastDate);
    }
  }

  private getSingleDateStr(date: moment.Moment) {
    const formattedDate =
      (this.translate.currentLang || this.translate.defaultLang) === 'en'
        ? date.format('DD MMM YYYY')
        : date.format('DD/MM/YYYY');
    return `${this.translate.instant('on')} ${formattedDate}`;
  }

  private getMultipleDateStr(initialDate: moment.Moment, lastDate: moment.Moment) {
    return `${this.translate.instant('from')} ${initialDate.format('DD MMM')} ${this.translate.instant(
      'to',
    )} ${lastDate.format('DD MMM YYYY')}`;
  }
}
